import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" fill="none" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.2578 2C20.3289 2 22.0078 3.67893 22.0078 5.75V10.1875C22.0075 10.6014 21.6718 10.9375 21.2578 10.9375C20.8441 10.9372 20.5081 10.6012 20.5078 10.1875V8.58887H10.9033V20.5078H12.0039C12.4181 20.5078 12.7538 20.8437 12.7539 21.2578C12.7536 21.6718 12.418 22.0078 12.0039 22.0078H5.75C3.67929 22.0076 2.00026 20.3285 2 18.2578V5.75C2 3.67908 3.67913 2.00023 5.75 2H18.2578ZM3.5 18.2578C3.50026 19.5001 4.50772 20.5076 5.75 20.5078H9.40332V14.75H3.5V18.2578ZM3.5 13.25H9.40332V8.58887H3.5V13.25ZM5.75 3.5C4.50756 3.50023 3.5 4.5075 3.5 5.75V7.08887H9.40332V3.5H5.75ZM10.9033 7.08887H20.5078V5.75C20.5078 4.50736 19.5005 3.5 18.2578 3.5H10.9033V7.08887Z"
        />
        <path
          d="M19.5527 16.25C19.9668 16.2502 20.3027 16.5859 20.3027 17C20.3027 17.4141 19.9668 17.7498 19.5527 17.75H15.6953L16.2373 18.3467C16.5157 18.653 16.4935 19.1266 16.1875 19.4053C15.8811 19.6838 15.4066 19.6617 15.1279 19.3555L13.4453 17.5049C13.2456 17.2852 13.1944 16.9678 13.3145 16.6963C13.4346 16.425 13.7033 16.25 14 16.25H19.5527Z"
        />
        <path
          d="M17.9688 11.4854C18.2529 11.184 18.7279 11.1701 19.0293 11.4541L20.9922 13.3047C21.2158 13.5155 21.2882 13.8423 21.1748 14.1279C21.0613 14.4134 20.7848 14.6006 20.4775 14.6006H14C13.5859 14.6005 13.25 14.2647 13.25 13.8506C13.2501 13.4366 13.586 13.1007 14 13.1006H18.5879L18 12.5459C17.6988 12.2618 17.6848 11.7867 17.9688 11.4854Z"
        />
      </svg>
    ),
  },
});
